import React from "react";

// Window showing every change the AI has made up to the current step
export default function AIChangesPanel({ wf, step, started }) {
  if (!wf || !started) {
    return (
      <div className="lcx-box">
        <p style={{ fontSize: "0.8rem", opacity: 0.6, margin: 0 }}>
          Run the workflow to see a live record of every AI-made change.
        </p>
      </div>
    );
  }

  const aiSteps = wf.steps
    .slice(0, step + 1)
    .map((s, i) => ({ ...s, index: i }))
    .filter((s) => (s.tags || []).includes("ai"));

  return (
    <div className="lcx-box" style={{ maxHeight: "340px", overflowY: "auto" }}>
      <div style={{ fontWeight: 700, marginBottom: "0.6rem", color: "#4FC3C3" }}>
        🤖 AI Change Log <span style={{ opacity: 0.65, fontWeight: 400, fontSize: "0.75rem" }}>— {aiSteps.length} AI-assisted step{aiSteps.length === 1 ? "" : "s"} · every change requires human verification</span>
      </div>
      {aiSteps.length === 0 ? (
        <p style={{ fontSize: "0.8rem", opacity: 0.65, margin: 0 }}>No AI-made changes yet in this run.</p>
      ) : (
        aiSteps.map((s) => (
          <div key={s.index} style={{ marginBottom: "0.75rem", padding: "0.6rem 0.7rem", border: "1px solid rgba(79,195,195,0.35)", borderRadius: "8px" }}>
            <div style={{ fontSize: "0.8rem", fontWeight: 700 }}>
              {s.icon} {s.label} <span style={{ opacity: 0.6, fontWeight: 400 }}>· {s.reg}</span>
            </div>
            <div style={{ fontSize: "0.75rem", opacity: 0.8, margin: "0.25rem 0", fontStyle: "italic" }}>
              {s.agent}
            </div>
            {s.fields.filter((f) => f.c === "hl").map((f) => (
              <div key={f.k} style={{ fontSize: "0.75rem", padding: "0.15rem 0" }}>
                <span style={{ color: "#4FC3C3" }}>＋ {f.k}:</span> <span style={{ opacity: 0.85 }}>{f.v}</span>
              </div>
            ))}
          </div>
        ))
      )}
    </div>
  );
}